<template>
  <b-modal
    id="confirm-attachment-modal"
    ref="confirm-attachment-modal"
    size="md"
    centered
    hide-header-close
    no-close-on-esc
    no-close-on-backdrop
    :title="$t('fleetTaskInstant.confirmModal.attachmentConfirmation.title')"
  >
    <div class="card-body p-1">
      <McAlert withIcon class="w-100 mb-3 px-2 py-1 align-items-center" variant="warning">
        <template #label>
          <p class="m-0" v-html="$t('fleetTaskInstant.confirmModal.attachmentConfirmation.alertText')" />
        </template>
      </McAlert>
      <div v-html="$t('fleetTaskInstant.confirmModal.attachmentConfirmation.question', { total: attachments.length })" />
      <div class="proof-grid">
        <div v-for="(attachment, i) in attachments" :key="i" class="proof-wrapper">
          <img
            class="proof-image"
            :src="customHandlers?.handlePathUrl(attachment)"
            @click="handleOpenPreview(i)"
          />
          <div class="proof-name-wrapper">
            <span class="proof-name">{{ formatImageName(attachment.name) }}</span>
            <span class="proof-extension">{{ formatImageExtension(attachment.name) }}</span>
          </div>
        </div>
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0">
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('global.action.cancel')"
          @click="cancel"
        />
        <McButton variant="primary" text="Upload" @click="handleUpload" />
      </div>
    </template>
    <PreviewImage
      v-if="activeAttachmentIdx !== null"
      :attachments="attachments"
      :activeAttachmentIdx="activeAttachmentIdx"
      :customHandlers="customHandlers"
      @update:activeAttachmentIdx="activeAttachmentIdx = $event"
    />
  </b-modal>
</template>
<script>
import McAlert from '@/components/McAlert'
import McButton from '@/components/McButton'
import PreviewImage from './PreviewImage'

export default {
  components: {
    McAlert,
    McButton,
    PreviewImage,
  },
  props: {
    attachments: {
      type: Array,
      required: true,
    },
  },
  emits: ['handle-upload-attachment'],
  data() {
    return {
      activeAttachmentIdx: null,
      customHandlers: {
        handlePathUrl: (input) => {
          return (window.URL || window.webkitURL).createObjectURL(input)
        },
      },
    }
  },
  methods: {
    formatImageName(name) {
      var idxExtension = name.lastIndexOf('.')
      return name.substring(0, idxExtension)
      
    },
    formatImageExtension(name) {
      var idxExtension = name.lastIndexOf('.')
      return name.substring(idxExtension)
    },
    handleUpload() {
      this.$bvModal.hide('confirm-attachment-modal')
      this.$emit('handle-upload-attachment')
    },
    handleOpenPreview(idx) {
      this.activeAttachmentIdx = idx
    },
  }
}
</script>
<style lang="scss">
.proof-grid {
  display: grid;
  grid-template-columns: repeat(5, 90px);
  grid-auto-rows: 115px;
  gap: 12px;
  margin-top: 10px;
}

.proof-image {
  width: 90px;
  height: 90px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
}

.proof-image:hover {
  filter: brightness(0.9);
}

.proof-name-wrapper {
  display: flex;
  font-size: 11px;
  font-style: italic;
  justify-content: center;
  margin-top: 3px;
  padding: 0 4px;
  width: 100%;

  .proof-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

@media (min-width: 992px) {
  #confirm-attachment-modal .modal-md {
    max-width: fit-content !important;
  }
}

@media (min-width: 576px) {
  #confirm-attachment-modal .modal-dialog {
    max-width: fit-content !important;
  }
}
</style>